import { mode, transparentize } from '@chakra-ui/theme-tools';
const baseStyle = {
    borderRadius: 'base',
    ':focus:not(:focus-visible)': {
        boxShadow: 'none',
    },
};
const sizes = {
    xl: {
        h: 12,
        minW: 12,
        fontSize: 'lg',
        px: 6,
    },
    lg: {
        h: 10,
        minW: 10,
        fontSize: 'md',
        px: 5,
    },
    md: {
        h: 8,
        minW: 8,
        fontSize: 'sm',
        px: 4,
    },
    sm: {
        h: 6,
        minW: 6,
        fontSize: 'xs',
        px: 3,
    },
};
const defaultProps = {
    size: 'md',
    variant: 'solid',
    colorScheme: 'gray',
};
const getGhostStyle = (props) => {
    const { theme, colorScheme } = props;
    return {
        color: colorScheme === 'gray'
            ? mode('gray.900', 'gray.0')(props)
            : mode(`${colorScheme}.600`, `${colorScheme}.300`)(props),
        _hover: {
            bg: mode(transparentize('gray.500', 0.1)(theme), transparentize('gray.300', 0.1)(theme))(props),
        },
        _active: {
            bg: mode(transparentize('gray.500', 0.3)(theme), transparentize('gray.300', 0.3)(theme))(props),
        },
        _disabled: {
            opacity: 1.0,
            color: mode(transparentize('gray.900', 0.3)(theme), transparentize('gray.0', 0.3)(theme))(props),
        },
        _focusVisible: {
            boxShadow: 'none',
            outlineOffset: '2px',
            outline: mode('1px solid black', '1px solid white')(props),
        },
    };
};
const getOutlineStyle = (props) => {
    const { theme } = props;
    return {
        ...getGhostStyle(props),
        border: '1px solid',
        borderColor: mode(transparentize('gray.500', 0.5)(theme), transparentize('gray.300', 0.5)(theme))(props),
    };
};
const getSolidStyle = (props) => {
    const { colorScheme, theme } = props;
    if (colorScheme === 'gray') {
        return {
            bg: mode('gray.900', 'gray.0')(props),
            color: mode('gray.0', 'gray.900')(props),
            _hover: {
                bg: mode('gray.800', 'gray.50')(props),
                _disabled: {
                    opacity: 1,
                    bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                },
            },
            _active: {
                bg: mode('gray.700', 'gray.100')(props),
            },
            _disabled: {
                opacity: 1,
                bg: mode(transparentize('gray.900', 0.1)(theme), transparentize('gray.0', 0.1)(theme))(props),
                color: mode(transparentize('gray.900', 0.3)(theme), transparentize('white', 0.3)(theme))(props),
            },
            _focusVisible: {
                boxShadow: 'none',
                outlineOffset: '2px',
                outline: mode('1px solid black', '1px solid white')(props),
            },
        };
    }
    return {
        bg: mode(`${colorScheme}.500`, `${colorScheme}.300`)(props),
        color: mode('gray.0', 'gray.900')(props),
        _hover: {
            bg: mode(`${colorScheme}.600`, `${colorScheme}.200`)(props),
            _disabled: {
                bg: mode('gray.900', 'gray.0')(props),
            },
        },
        _active: {
            bg: mode(`${colorScheme}.700`, `${colorScheme}.100`)(props),
        },
        _disabled: {
            bg: mode('gray.900', 'gray.0')(props),
            opacity: 0.1,
        },
        _focusVisible: {
            boxShadow: 'none',
            outlineOffset: '2px',
            outline: mode(`1px solid ${transparentize(`${colorScheme}.600`, 1.0)(theme)}`, `1px solid ${transparentize(`${colorScheme}.200`, 1.0)(theme)}`)(props),
        },
    };
};
const variants = {
    solid: getSolidStyle,
    outline: getOutlineStyle,
    ghost: getGhostStyle,
};
export default {
    baseStyle,
    sizes,
    variants,
    defaultProps,
};
//# sourceMappingURL=button.js.map